<template>
    <div class="main">
        <c-panel :title="titulo" :titleIcon="icone">
            <carga></carga>
        </c-panel>
    </div>
</template>
<script>
import carga from "./carga"
export default {
    components: { carga },
    data () { return { titulo: '', icone: '' } },
    created () {
        this.titulo = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : ''
        this.icone = 'fas fa-chart-line'
    }
}
</script>
